import axios from 'axios';

const API_URLS = { BASE: process.env.REACT_APP_PANEL };

// Create a fresh instance (not exported directly)
const createApiInstance = (baseURL) => {
  const instance = axios.create({
    baseURL,
    timeout: 30000,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  instance.interceptors.request.use((config) => {
    const token = sessionStorage.getItem("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  return instance;
};

let api = createApiInstance(API_URLS.BASE);

export const getPanelsByCreatingUser = (id) => api.get(`panels-mngmnt/panels-by-created-user/?created_by_id=${id}`);
export const getPanelbyParticipant = (id, currentPage = 1, itemsPerPage = 10, searchTerm = '') =>
  api.get(`panels-mngmnt/panels-by-participant/`, {
    params: {
      participant_id: id,
      currentPage,
      itemsPerPage,
      searchTerm,
    },
  });
  
export const getPanelsByAdminUnitOrgUnit = (org_unit, admin_unit, currentPage = 1, itemsPerPage = 10, searchTerm = '') =>
  api.get(`panels-mngmnt/panels-by-admin-unit-org-unit/`, {
    params: {
      org_unit: org_unit,
      admin_unit: admin_unit,
      currentPage,
      itemsPerPage,
      searchTerm,
    },
  });


export const getPanelsByAdminUnit = (admin_unit, currentPage = 1, itemsPerPage = 10, searchTerm = '') =>
  api.get(`panels-mngmnt/panels-by-admin-unit/`, {
    params: {
      admin_unit: admin_unit,
      currentPage,
      itemsPerPage,
      searchTerm,
    },
  });

export const getPanelsByCaseIds = (case_ids, currentPage = 1, itemsPerPage = 10, searchTerm = '') =>
  api.get(`panels-mngmnt/panels-by-case_ids/`, {
    params: {
      case_ids: case_ids,
      currentPage,
      itemsPerPage,
      searchTerm,
    },
  });

export const getPanelsById = (id) => api.get(`panels-mngmnt/${id}/`)
export const getPanelParticipantsByPanelId = (id) => api.get(`panel-participants/get_panel_participanet_by_panel_id/?panel_id=${id}`)
export const getPanelChatByPanelId = (id) => api.get(`panel-chats/get_panel_chat_by_panel_id/?panel_id=${id}`)
export const sendPanelChatMessage = (data) => api.post('panel-chats/', data)
export const createPanelParticipant = (data) => api.post('panel-participants/', data)
export const removePanelParticipant = (id, data) => api.put(`panel-participants/${id}/`, data)
export const getPanelChatDocument = (id) => api.get(`panel-chat-documents/read_panel_chat_documents/${id}/`, { responseType: 'blob' })
export const createPanel = (data) => api.post('panels-mngmnt/', data)
export const createPanelPoll = (data) => api.post('panel-poll/', data)
export const getPollsByPanel = (id) => api.get(`panel-poll/get_polls_by_panel/?panel_id=${id}`)
export const createPanelVote = (data) => api.post('panel-poll-vote/', data)
export const updatePanelAgenda = (data) => api.post(`panels-mngmnt/updated-agenda/`, data);
export const createMinute = (data) => api.post('panel-minute/', data)
export const getMinuteByPanelId = (id) => api.get(`panel-minute/get_minute_panel_id/?panel_id=${id}`)
export const getMinuteDocuments = (id) => api.get(`panel-minute-documents/read_minute_documents/${id}/`, { responseType: 'blob' })
export const updatePanelMeeting = (id, data) => api.put(`panels-mngmnt/${id}/`, data)